import { es } from "@orbis/shared";
import { CheckIcon, MinusIcon } from "../../components/icons";
import type { Role } from "../../lib/types";

/** What each role can do. Mirrors the API rules (roles middleware, assignee guard, team routes). */
const CAPABILITIES: { label: string; roles: Role[]; soon?: boolean }[] = [
  { label: "Ver la bandeja, los contactos y el equipo", roles: ["agent", "admin", "owner"] },
  { label: "Responder conversaciones sin asignar y las propias", roles: ["agent", "admin", "owner"] },
  { label: "Editar contactos y usar respuestas rápidas y plantillas", roles: ["agent", "admin", "owner"] },
  { label: "Responder, asignar y cerrar cualquier conversación", roles: ["admin", "owner"] },
  { label: "Crear respuestas rápidas y sincronizar plantillas", roles: ["admin", "owner"] },
  { label: "Invitar y quitar asesores y administradores", roles: ["admin", "owner"] },
  { label: "Invitar propietarios y cambiar roles", roles: ["owner"] },
  { label: "Plan, pagos y facturación", roles: ["owner"], soon: true },
  { label: "Verificación en dos pasos obligatoria", roles: ["agent", "admin", "owner"] },
];

const ORDER: Role[] = ["agent", "admin", "owner"];

export function RoleSummary({ role }: { role: Role }) {
  return <p className="muted role-summary">{es.roles[role].summary}</p>;
}

export function RolesTable() {
  return (
    <details className="disclosure roles-help">
      <summary>¿Qué puede hacer cada rol?</summary>
      <div className="disclosure-body">
        {/* Phones: one row per permission with the roles that have it, names written normally. */}
        <ul className="roles-list only-phone-block">
          {CAPABILITIES.map((c) => (
            <li key={c.label}>
              <span>
                {c.label}
                {c.soon && <span className="faint"> (pronto)</span>}
              </span>
              <span className="role-chips">
                {c.roles.length === ORDER.length ? (
                  <span className="role-chip all">Todos los roles</span>
                ) : (
                  ORDER.filter((r) => c.roles.includes(r)).map((r) => (
                    <span key={r} className="role-chip">
                      {es.roles[r].label}
                    </span>
                  ))
                )}
              </span>
            </li>
          ))}
        </ul>
        <div className="table-scroll hide-phone">
          <table className="table roles-table">
            <thead>
              <tr>
                <th />
                {ORDER.map((r) => (
                  <th key={r}>{es.roles[r].label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {CAPABILITIES.map((c) => (
                <tr key={c.label}>
                  <td>
                    {c.label}
                    {c.soon && <span className="faint"> (pronto)</span>}
                  </td>
                  {ORDER.map((r) => (
                    <td key={r} className="role-cell">
                      {c.roles.includes(r) ? (
                        <span className="yes">
                          <CheckIcon />
                          <span className="sr-only">Sí</span>
                        </span>
                      ) : (
                        <span className="no">
                          <MinusIcon />
                          <span className="sr-only">No</span>
                        </span>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </details>
  );
}
